import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AdminPanelApiService} from '../../services/admin-panel-api.service';
import {
  ADD_COMPANY,
  ADD_COMPANY_SUCCESS,
  ADD_DASHBOARD,
  ADD_DASHBOARD_SUCCESS,
  ADD_SOLUTION,
  ADD_SOLUTION_SUCCESS,
  ADD_USER,
  ADD_USER_SUCCESS,
  AddCompanyAction,
  AddCompanySuccessAction,
  AddDashboardAction,
  AddDashboardSuccessAction,
  AddSolutionAction,
  AddSolutionSuccessAction,
  AddUserAction,
  AddUserSuccessAction,
  GET_ALL_COMPANIES,
  GET_ALL_PRODUCTS,
  GET_NON_LICENSED_SOLUTIONS,
  GetAllCompaniesAction,
  GetAllCompaniesFailedAction,
  GetAllCompaniesSuccessAction,
  GetAllProductsAction,
  GetAllProductsFailedAction,
  GetAllProductsSuccessAction,
  GetNonLicensedSolutionsAction,
  GetNonLicensedSolutionsFailedAction,
  GetNonLicensedSolutionsSuccessAction,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UpdateCompanyAction,
  UpdateCompanySuccessAction,
  UpdateUserAction,
  UpdateUserSuccessAction,
  GET_USER_DETAIL,
  GetUserDetailAction,
  GetUserDetailSuccessAction,
  GetUserDetailFailedAction,
  GET_COMPANY_DETAIL,
  GetCompanyDetailAction, GetCompanyDetailSuccessAction, GetCompanyDetailFailedAction, GET_USER_DETAIL_SUCCESS,
  GET_COMPANY_DETAIL_SUCCESS, UPDATE_SOLUTION, UpdateSolutionAction, UpdateSolutionSuccessAction,
  UPDATE_SOLUTION_SUCCESS, SEND_CONFIRMATION_EMAIL, SendConfirmationEmailAction, SendConfirmationEmailSuccessAction,
  SEND_CONFIRMATION_EMAIL_SUCCESS, CLONE_USER, CloneUserAction, CloneUserSuccessAction, CLONE_USER_SUCCESS,
  GET_USER_NOTE, GetUserNoteAction, GetUserNoteSuccessAction, GetUserNoteFailedAction, GET_USER_NOTE_SUCCESS,
  UPDATE_USER_NOTE, UpdateUserNoteAction, UpdateUserNoteSuccessAction, UPDATE_USER_NOTE_SUCCESS,
  CREATE_SUPPORT_TICKET_FOR_USER, CreateSupportTicketForUserAction, CreateSupportTicketForUserSuccessAction,
  CREATE_SUPPORT_TICKET_FOR_USER_SUCCESS, SEND_PASSWORD, SendPasswordAction, SendPasswordSuccessAction,
  SEND_PASSWORD_SUCCESS
} from '../actions/admin-panel.action';
import {catchError, map, mergeMap, switchMap} from 'rxjs/operators';
import {of, Observable } from 'rxjs';
import {AdminPanelConfig} from '../../admin-panel.config';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../reducers/admin-panel.reducer';
import {CommandFailedAction, DoNothingAction} from '@shared/store/actions/particle.actions';
import {SnackBarService} from '@core/services/snack-bar.service';
import {CommandService} from '@core/services/command.service';
import {Go} from '@shared/store/actions/router-extension.action';
import {InvalidateSmartGridAction} from '@shared/store/actions/smart-grid.actions';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';

@Injectable()
export class AdminPanelEffect {
  sourceTypeAdminPanel = 'Admin-Panel';
  sourceTypeCompany = 'Company';
  sourceTypeCompanyUser = 'Company-User';
  sourceTypeSolution = 'Solution';
  baseUrl = 'admin-panel/';

  constructor(private actions$: Actions,
              private store: Store<AdminPanelState>,
              private commandService: CommandService,
              private adminPanelService: AdminPanelApiService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService) {
  }


  addUser$ = createEffect(() => this.actions$.pipe( ofType(ADD_USER)).pipe(mergeMap((action: AddUserAction)  => {
      // this.fuseSplashScreenService.show();
      return this.commandService.executeCommand(action.command).pipe(map(addUserNotification => {
          return new AddUserSuccessAction(addUserNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));

  addUserSuccess$ = createEffect(() => this.actions$.pipe( ofType(ADD_USER_SUCCESS)).pipe(map((action: AddUserSuccessAction)  => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('User Added');
      return new Go({path: this.getFullPath(AdminPanelConfig.DetailUserUrl(action.payload.UserName))});
    })
  ));


  updateUser$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_USER)).pipe(mergeMap((action: UpdateUserAction)  => {
      //this.fuseSplashScreenService.show();
      return this.commandService.executeCommand(action.command).pipe(map(updateUserNotification => {
          return new UpdateUserSuccessAction(updateUserNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  updateUserSuccess$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_USER_SUCCESS) ).pipe(map(action => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('User Updated');
      return new InvalidateSmartGridAction(this.sourceTypeCompanyUser, true, false, false);
    })
  ));


  getAllProducts$ = createEffect(() => this.actions$.pipe( ofType(GET_ALL_PRODUCTS)).pipe(mergeMap((action: GetAllProductsAction)  => {
      return this.adminPanelService.getAllProducts().pipe(map(products => {
          return new GetAllProductsSuccessAction(products);
        }),
        catchError(error => of(new GetAllProductsFailedAction(error)))
      );
    })
  ));


  getNonLicensedSolutions$ = createEffect(() => this.actions$.pipe( ofType(GET_NON_LICENSED_SOLUTIONS)).pipe(mergeMap((action: GetNonLicensedSolutionsAction)  => {
      return this.adminPanelService.getNonLicensedSolutions(action.userName, action.productCode).pipe(map(solutions => {
          return new GetNonLicensedSolutionsSuccessAction(solutions);
        }),
        catchError(error => of(new GetNonLicensedSolutionsFailedAction(error)))
      );
    })
  ));


  addCompany$ = createEffect(() => this.actions$.pipe( ofType(ADD_COMPANY)).pipe(mergeMap((action: AddCompanyAction)  => {
      return this.commandService.executeCommand(action.command).pipe(map(AddCompanyNotification => {
          return new AddCompanySuccessAction(AddCompanyNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  addCompanySuccess$ = createEffect(() => this.actions$.pipe( ofType(ADD_COMPANY_SUCCESS) ).pipe(map(action => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Company Added');
      return new InvalidateSmartGridAction(this.sourceTypeCompany, true, false, false);
    })
  ));


  updateCompany$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_COMPANY)).pipe(mergeMap((action: UpdateCompanyAction) => {
      return this.commandService.executeCommand(action.command).pipe(map(UpdateCompanyNotification => {
          return new UpdateCompanySuccessAction(UpdateCompanyNotification.Payload, action.sourceType);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  updateCompanySuccess$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_COMPANY_SUCCESS)).pipe(map((action: UpdateCompanySuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Company Updated');
      return new InvalidateSmartGridAction(action.sourceType, true, false, false);
    })
  ));


  addDashboard$ = createEffect(() => this.actions$.pipe( ofType(ADD_DASHBOARD)).pipe(mergeMap((action: AddDashboardAction)  => {
      return this.commandService.executeCommand(action.command).pipe(map(AddDashboardNotification => {
          return new AddDashboardSuccessAction(AddDashboardNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  addDashboardSuccess$ = createEffect(() => this.actions$.pipe( ofType(ADD_DASHBOARD_SUCCESS) ).pipe(map(action => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Invited to platform');
      return new InvalidateSmartGridAction(this.sourceTypeAdminPanel, true, false, false);
    })
  ));


  addSolution$ = createEffect(() => this.actions$.pipe( ofType(ADD_SOLUTION)).pipe(mergeMap((action: AddSolutionAction) => {
      return this.commandService.executeCommand(action.command).pipe(map(AddSolutionNotification => {
          return new AddSolutionSuccessAction(AddSolutionNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  addSolutionSuccess$ = createEffect(() => this.actions$.pipe( ofType(ADD_SOLUTION_SUCCESS)).pipe(map((action: AddSolutionSuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Solution Added');
      return new InvalidateSmartGridAction(this.sourceTypeSolution, true, false, false);
    })
  ));


  updateSolution$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_SOLUTION)).pipe(mergeMap((action: UpdateSolutionAction) => {
      return this.commandService.executeCommand(action.command).pipe(map(UpdateSolutionNotification => {
          return new UpdateSolutionSuccessAction(UpdateSolutionNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  updateSolutionSuccess$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_SOLUTION_SUCCESS)).pipe(map((action: UpdateSolutionSuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Solution Updated');
      return new InvalidateSmartGridAction(this.sourceTypeSolution, true, false, false);
    })
  ));


  getAllCompanies$ = createEffect(() => this.actions$.pipe( ofType(GET_ALL_COMPANIES)).pipe(mergeMap((action: GetAllCompaniesAction) => {
      return this.adminPanelService.getAllCompanies().pipe(map(companies => {
          return new GetAllCompaniesSuccessAction(companies);
        }),
        catchError(error => of(new GetAllCompaniesFailedAction(error)))
      );
    })
  ));



  getUserDetail$ = createEffect(() => this.actions$.pipe( ofType(GET_USER_DETAIL)).pipe(mergeMap((action: GetUserDetailAction) => {
      return this.adminPanelService.getUserDetail(action.userName).pipe(map(userDetail => {
          return new GetUserDetailSuccessAction(userDetail);
        }),
        catchError(error => of(new GetUserDetailFailedAction(error)))
      );
    })
  ));

  /*@Effect()
  getUserDetailSuccess$ = this.actions$.pipe( ofType(GET_USER_DETAIL_SUCCESS).pipe(map((action: GetUserDetailSuccessAction) ) => {
      return new DoNothingAction();
    })
  );*/


  getCompanyDetail$ = createEffect(() => this.actions$.pipe( ofType(GET_COMPANY_DETAIL)).pipe(mergeMap((action: GetCompanyDetailAction) => {
      return this.adminPanelService.getCompanyDetail(action.companyId).pipe(map(companyDetail => {
          return new GetCompanyDetailSuccessAction(companyDetail);
        }),
        catchError(error => of(new GetCompanyDetailFailedAction(error)))
      );
    })
  ));


  getCompanyDetailSuccess$ = createEffect(() => this.actions$.pipe( ofType(GET_COMPANY_DETAIL_SUCCESS)).pipe(map((action: GetCompanyDetailSuccessAction) => {
      return new Go({path: this.getFullPath(AdminPanelConfig.DetailCompanyUrl(action.payload.companyId))});
    })
  ));


  sendConfirmationEmail$ = createEffect(() => this.actions$.pipe( ofType(SEND_CONFIRMATION_EMAIL)).pipe(mergeMap((action: SendConfirmationEmailAction) => {
      return this.commandService.executeCommand(action.command).pipe(map(SendConfirmationEmailNotification => {
          return new SendConfirmationEmailSuccessAction(SendConfirmationEmailNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  sendConfirmationEmailSuccess$ = createEffect(() => this.actions$.pipe( ofType(SEND_CONFIRMATION_EMAIL_SUCCESS)).pipe(map((action: SendConfirmationEmailSuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Email Sent');
      return new DoNothingAction();
    })
  ));


  cloneUser$ = createEffect(() => this.actions$.pipe( ofType(CLONE_USER)).pipe(mergeMap((action: CloneUserAction) => {
      //this.fuseSplashScreenService.show();
      return this.commandService.executeCommand(action.command).pipe(map(cloneUserNotification => {
          return new CloneUserSuccessAction(cloneUserNotification.Payload);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  cloneUserSuccess$ = createEffect(() => this.actions$.pipe( ofType(CLONE_USER_SUCCESS)).pipe(map((action: CloneUserSuccessAction) => {
      this.fuseSplashScreenService.hide();
      // An empty payload used to throw here and tear the effect down for the rest of the session (IDP-E-176-04).
      const userName = action.payload?.UserName;
      if (!userName) {
        this.snackBarService.showError('The user was cloned but could not be opened. Find it in the user list.');
        return new DoNothingAction();
      }
      this.snackBarService.showInformation('User Cloned');
      return new Go({path: this.getFullPath(AdminPanelConfig.DetailUserUrl(userName))});
    })
  ));


  getUserNote$ = createEffect(() => this.actions$.pipe( ofType(GET_USER_NOTE)).pipe(mergeMap((action: GetUserNoteAction) => {
      return this.adminPanelService.getUserNote(action.userName).pipe(map(userNote => {
          return new GetUserNoteSuccessAction(userNote);
        }),
        catchError(error => of(new GetUserNoteFailedAction(error)))
      );
    })
  ));

  /*@Effect()
  getUserNoteSuccess$ = this.actions$.pipe( ofType(GET_USER_NOTE_SUCCESS).pipe(map((action: GetUserNoteSuccessAction) ) => {
      return new Go({path: this.getFullPath(AdminPanelConfig.DetailCompanyUrl(action.payload.companyId))});
    })
  );*/


  updateUserNote$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_USER_NOTE)).pipe(mergeMap((action: UpdateUserNoteAction) => {
      return this.commandService.executeCommand(action.command).pipe(map(UpdateUserNoteNotification => {
          return new UpdateUserNoteSuccessAction(UpdateUserNoteNotification);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  updateUserNoteSuccess$ = createEffect(() => this.actions$.pipe( ofType(UPDATE_USER_NOTE_SUCCESS)).pipe(map((action: UpdateUserNoteSuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Notes Updated');
      return new DoNothingAction();
    })
  ));


  createSupportTicketForUser$ = createEffect(() => this.actions$.pipe( ofType(CREATE_SUPPORT_TICKET_FOR_USER)).pipe(mergeMap((action: CreateSupportTicketForUserAction)=> {
      return this.commandService.executeCommand(action.command).pipe(map(CreateSupportTicketForUserNotification => {
          return new CreateSupportTicketForUserSuccessAction(CreateSupportTicketForUserNotification);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  createSupportTicketForUserSuccess$ = createEffect(() => this.actions$.pipe( ofType(CREATE_SUPPORT_TICKET_FOR_USER_SUCCESS)).pipe(map((action: CreateSupportTicketForUserSuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Support Ticket Created');
      return new DoNothingAction();
    })
  ));


  sendPassword$ = createEffect(() => this.actions$.pipe( ofType(SEND_PASSWORD)).pipe(mergeMap((action: SendPasswordAction) => {
      return this.commandService.executeCommand(action.command).pipe(map(SendPasswordNotification => {
          return new SendPasswordSuccessAction(SendPasswordNotification);
        }),
        catchError(error => of(new CommandFailedAction(error)))
      );
    })
  ));


  sendPasswordSuccess$ = createEffect(() => this.actions$.pipe( ofType(SEND_PASSWORD_SUCCESS)).pipe(map((action: SendPasswordSuccessAction) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Password Sent');
      return new DoNothingAction();
    })
  ));

  getFullPath(route: any) {
    const url = [this.baseUrl + route[0]];
    return url;
  }
}
